import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import ReadonlyEditor from '../drafteditor/components/ReadonlyEditor';

const AcceptBookingNoteModal = ({
    title,
    content,
    buttonLabel,
    showModal,
    onSubmit,
    MODAL_TYPE
}) => {
    return (
        <Dialog
            open
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <ReadonlyEditor value={content} />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        showModal(MODAL_TYPE.NONE);
                        onSubmit();
                    }}
                    variant="contained"
                    color="primary"
                >
                    {buttonLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AcceptBookingNoteModal;
